import React from 'react';
import proptypes from 'prop-types';
const { shape } = proptypes;
import { extend } from '@thd-nucleus/data-sources';
import { FulfillmentPodShipping, FulfillmentPodStore, FulfillmentPod } from '@thd-olt-component-react/fulfillment';

const MultiParentItemFulfillment = ({ product }) => {
  const { multiParentFulfillment } = product?.features || {};

  if (!product || !multiParentFulfillment) {
    return null;
  }

  return (
    <div
      data-testid="multi-parent-item-fulfillment-pod"
    >
      <FulfillmentPod
        className="sui-grid sui-grid-rows-1 sui-pt-2"
        hideStoreNameLink
      >
        <FulfillmentPodStore directData={product} />
        <FulfillmentPodShipping directData={product} />
      </FulfillmentPod>
    </div>
  );
};

MultiParentItemFulfillment.propTypes = {
  product: shape({}).isRequired
};

MultiParentItemFulfillment.dataModel = extend(
  FulfillmentPodShipping,
  FulfillmentPodStore
);

MultiParentItemFulfillment.displayName = 'MultiParentItemFulfillment';
export { MultiParentItemFulfillment };